import Header from "@/atomic/atoms/Header";
import { PropsView } from "../Models/finished";
import { Suspense } from "react";
import TicketModal from "@/atomic/organisms/TicketModal";
import Loading from "@/atomic/atoms/Loading";
import Modal from "@/atomic/atoms/Modal";
import PlanSelection, { Plan } from "@/atomic/organisms/PlanSelection";
import useI18n from "@/hooks/useI18n";

export default function RechargeFinishedView({
  goBack,
  gotToHome,
  isVisibleModal,
  toggleModal,
  invoice,
  generatePDF,
  isLoading,
  openInvoice,
  error,
  toggleError
}: PropsView) {

  return (
    <div className="relative flex flex-col">
      <Header
        title="Pagamento"
        hasLeftButton
        goBack={goBack}
      />
      <main className="px-4 py-3 md:py-6 flex justify-center items-center h-[calc(100vh-72px)] overflow-y-auto bg-white">
        <article className="h-full flex flex-col w-full items-center justify-center">
          <div className="flex flex-col w-full max-w-[1400px] mx-auto justify-center">
            <div className="flex items-center justify-center w-full flex-col mb-4 md:mb-6">
              <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-2 md:mb-3">
                <svg className="w-10 h-10 md:w-12 md:h-12 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h2 className="text-xl md:text-3xl font-bold text-black text-center mb-1 md:mb-2">Sucesso!</h2>
              <h3 className="text-xs md:text-base text-center text-[#525252] px-2">Seu pagamento foi realizado.</h3>
            </div>
            
            <div className="flex justify-center items-center w-full mx-auto mb-3 md:mb-6">
              <PlanSelection />
            </div>

            <div className="w-full max-w-full md:w-[calc(480px)] mx-auto">
              <div className="flex items-center flex-col mt-3 md:mt-6 px-2 my-4">
                <button onClick={gotToHome} type="button" className="w-full h-[calc(50px)] md:h-[calc(60px)] rounded-lg border border-black bg-white text-black font-medium mb-3 md:mb-3 text-sm md:text-base">Ir para o início</button>
                <button onClick={openInvoice} type="button" className="text-black font-medium text-xs md:text-base">Ver recibo</button>
              </div>
            </div>
          </div>
        </article>
      </main>
      {isVisibleModal && <Suspense fallback={null}>
        <TicketModal
          toggleModal={toggleModal}
          invoice={invoice}
          generatePDF={generatePDF}
        />
      </Suspense>}
      {error && <Suspense fallback={null}>
        <Modal
          title="Ops!"
          message="Seu recibo ainda não está disponível. Em alguns instantes você poderá visualizá-lo."
          actionMessage="Verificar novamente"
          action={() => {
            toggleError();
            openInvoice();
          }}
          actionSecondMessage="Ok, entendi"
          actionSecond={toggleError}
        />
      </Suspense>}
      {isLoading &&  <Suspense fallback={null}>
        <Loading />
      </Suspense>}
    </div>
  );
}
